<template>
  <table class="product-table">
    <thead>
      <tr>
        <th>ID</th>
        <th>图片</th>
        <th>标题</th>
        <th>标签</th>
        <th>排序</th>
        <th>状态</th>
        <th>操作</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="product in products" :key="product.id">
        <td>{{ product.id }}</td>
        <td><img :src="product.imageUrl" class="product-img" /></td>
        <td>{{ product.title }}</td>
        <td><span :class="`tag ${product.tag}`">{{ product.tag }}</span></td>
        <td>{{ product.sortOrder }}</td>
        <td><span :class="product.isActive ? 'status-active' : 'status-inactive'">{{ product.isActive ? '启用' : '禁用' }}</span></td>
        <td class="action-buttons">
          <button @click="handleEdit(product.id)" class="btn-edit">编辑</button>
          <!-- <button @click="handleEditHotspots(product)" class="btn-hotspot">热区编辑</button> -->
          <button @click="handleDelete(product)" class="btn-delete">删除</button>
        </td>
      </tr>
      <tr v-if="products.length === 0 && !loading">
        <td colspan="7" class="no-data">暂无数据</td>
      </tr>
      <tr v-if="loading">
        <td colspan="7" class="loading">加载中...</td>
      </tr>
    </tbody>
  </table>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';

// eslint-disable-next-line no-unused-vars
const props = defineProps({
  products: {
    type: Array,
    required: true
  },
  loading: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['edit', 'delete', 'edit-hotspots']);

const handleEdit = (id) => {
  emit('edit', id);
};

// const handleEditHotspots = (product) => {
//   emit('edit-hotspots', product);
// };

const handleDelete = (product) => {
  emit('delete', product);
};
</script>

<style scoped>
.product-table {
  width: 100%;
  border-collapse: collapse;
}

.product-table th,
.product-table td {
  padding: 12px;
  text-align: left;
  border-bottom: 1px solid #eee;
}

.product-table th {
  background-color: #f5f5f5;
  font-weight: bold;
}

.product-img {
  width: 50px;
  height: 50px;
  object-fit: cover;
  border-radius: 4px;
}

.tag {
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
}

.tag.首页不展示 {
  background-color: #ff4444;
  color: white;
}

.tag.首页展示 {
  background-color: #00C851;
  color: white;
}

/* .tag.推荐 {
  background-color: #FFC107;
  color: black;
} */

.status-active {
  color: #00C851;
}

.status-inactive {
  color: #ff4444;
}

.action-buttons {
  display: flex;
  gap: 8px;
}

.btn-edit {
  background-color: #42b983;
  color: white;
  border: none;
  padding: 4px 8px;
  border-radius: 4px;
  cursor: pointer;
}

.btn-hotspot {
  background-color: #409eff;
  color: white;
  border: none;
  padding: 4px 8px;
  border-radius: 4px;
  cursor: pointer;
}

.btn-delete {
  background-color: #ff4444;
  color: white;
  border: none;
  padding: 4px 8px;
  border-radius: 4px;
  cursor: pointer;
}

.no-data,
.loading {
  text-align: center;
  padding: 20px;
  color: #666;
}
</style>